import React from 'react';
import { observer } from 'mobx-react-lite';
import { ActionModal, Button, colors } from '@insurancemenu/imenu-components-lib';
import { ExitToApp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { redirectToRoute } from 'routes/redirectToRoute';
import { RouteV2Id } from 'routes/routesConfigV2';
import FavoriteProposalStepController from 'store/modules/initiate-quote/favoriteProposalStepController';
import { DescriptionStyled, NoDataPlaceholderStyled } from './styles';

interface Props {
  favoriteProposalStepController: FavoriteProposalStepController;
}

const NoFavoriteProposalsView: React.FC<Props> = observer(({ favoriteProposalStepController }) => {
  const { redirectModalDelegate, groupId } = favoriteProposalStepController;

  const redirectToGroupProfile = (): void => {
    redirectToRoute(RouteV2Id.GROUP_HUB, { groupId });
  };

  return (
    <>
      <NoDataPlaceholderStyled
        title="No favorite proposals match the current proposal details"
        text={
          <DescriptionStyled>
            <span>Mark a matching proposal as a favorite on the Group Profile page to make it available here</span>
            <Button color="primary" size="medium" onClick={redirectModalDelegate.open}>
              Go to Group profile
            </Button>
          </DescriptionStyled>
        }
      />
      <ActionModal
        show={redirectModalDelegate.isVisible}
        title="Leave Proposal Creation"
        subtitle={
          <span>
            Leaving now will exit the Proposal Creation flow <br /> and discard the information you&apos;ve entered
          </span>
        }
        icon={<ExitToApp width="5.6rem" height="5.6rem" color={colors.orange[600]} />}
        actionButtonText="Go to Group Profile"
        closeButtonText="Cancel"
        onClose={redirectModalDelegate.close}
        onAction={redirectToGroupProfile}
      />
    </>
  );
});

export default NoFavoriteProposalsView;
